(function () {
  var config = window.PROMO_GIFT_CONFIG;
  if (!config || !config.active) return;

  function isDealLive(deal) {
    if (!deal || deal.active !== true) return false;
    var now = new Date();
    if (deal.startsAt) {
      var startsAt = new Date(deal.startsAt);
      if (!isNaN(startsAt.getTime()) && now < startsAt) return false;
    }
    if (deal.endsAt) {
      var endsAt = new Date(deal.endsAt);
      if (!isNaN(endsAt.getTime()) && now > endsAt) return false;
    }
    return true;
  }

  var singleRewardDeals = (config.deals || []).filter(function (d) {
    return isDealLive(d) && d.offerType === 'SINGLE_REWARD' &&
           d.rewardOptions && d.rewardOptions[0] && d.rewardOptions[0].discountType === 'FREE';
  });
  if (!singleRewardDeals.length) return;

  function cartQualifiesForDeal(items, deal) {
    return items.some(function (item) {
      return deal.qualifyingProductIds.indexOf(item.product_id) !== -1 ||
             deal.qualifyingVariantIds.indexOf(item.variant_id) !== -1;
    });
  }

  function cartHasRewardForDeal(items, deal) {
    var rewardIds = deal.rewardOptions.map(function (o) { return o.variantId; });
    return items.some(function (item) {
      return rewardIds.indexOf(item.variant_id) !== -1;
    });
  }

  function cartHasPromoRewardForDeal(items, deal) {
    var rewardIds = deal.rewardOptions.map(function (o) { return o.variantId; });
    return items.some(function (item) {
      if (rewardIds.indexOf(item.variant_id) === -1) return false;
      return item.properties && item.properties['_promo_deal_number'] !== undefined;
    });
  }

  function addReward(deal) {
    var reward = deal.rewardOptions[0];
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: reward.variantId,
          quantity: 1,
          properties: {
            _promo_campaign: config.campaignName,
            _promo_deal_number: String(deal.dealNumber),
            _promo_reward_number: String(reward.rewardNumber)
          }
        }]
      })
    }).then(function (r) { return r.json(); });
  }

  function removeReward(items, deal) {
    var rewardIds = deal.rewardOptions.map(function (o) { return o.variantId; });
    var lineIndex = -1;
    items.forEach(function (item, i) {
      if (rewardIds.indexOf(item.variant_id) !== -1) lineIndex = i;
    });
    if (lineIndex === -1) return Promise.resolve();
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: lineIndex + 1, quantity: 0 })
    }).then(function (r) { return r.json(); });
  }

  function refreshCartDrawer() {
    var cart = document.querySelector('cart-drawer');
    if (!cart) return;
    var sections = cart.getSectionsToRender().map(function (s) { return s.id; });
    fetch(window.location.pathname + '?sections=' + sections.join(','))
      .then(function (r) { return r.json(); })
      .then(function (data) { cart.renderContents({ sections: data }); })
      .catch(function (err) { console.error('[cart-promo-gift] drawer refresh failed:', err); });
  }

  function syncAllDeals() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items;
        var ops = [];
        singleRewardDeals.forEach(function (deal) {
          var qualifies = cartQualifiesForDeal(items, deal);
          var hasReward = cartHasRewardForDeal(items, deal);
          var hasPromoReward = cartHasPromoRewardForDeal(items, deal);
          if (qualifies && !hasReward) ops.push(addReward(deal));
          else if (!qualifies && hasPromoReward) ops.push(removeReward(items, deal));
        });
        if (!ops.length) return Promise.resolve(null);
        return Promise.all(ops);
      })
      .then(function (result) {
        if (result !== null) refreshCartDrawer();
      })
      .catch(function (err) { console.error('[cart-promo-gift]', err); });
  }

  function onCartUpdate(event) {
    if (!event || event.source !== 'product-form') return;
    syncAllDeals();
  }

  function init() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') {
      setTimeout(init, 100);
      return;
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
